import { SupplementaryEquipmentTakeBackComponent } from '@sdbn/common';
import { SupplementaryEquipmentHandoutComponent } from '@sdbn/common';
import { RegisterEntranceDialogData, RegisterEntranceComponent } from './../dialog/register-entrance/component/register-entrance.component';
import { MatDialog } from '@angular/material/dialog';
import { RegisterEntranceCombinedDialogData, RegisterEntranceCombinedComponent } from './../component/register-entrance-combined/register-entrance-combined.component';
import { TMCClientParameters } from '@sdbn/tmc-common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AppServerAPI } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  private selectTransportSubject = new Subject<number>();
  public selectTransport$ = this.selectTransportSubject.asObservable();

  private clientParameters = TMCClientParameters;

  constructor(
    private appServerAPI: AppServerAPI,
    private dialog: MatDialog,
    private configurationService: AppClientConfigurationService) { }


  /** Notifies all interested components about the selection request for this transport. */
  public selectTransport(transportId: number) {
    this.selectTransportSubject.next(transportId);
  }

  emergencyCall(language: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `/client/control/transportoverview/ermergency-call`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, language).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

  public openHandoutSupplementaryEquipmentDialog(transportId: number, callback: (result: any) => void) {

    const dialogRef = this.dialog.open(SupplementaryEquipmentHandoutComponent, {
      maxHeight: '95vh',
      data: { transportId: transportId },
      panelClass: 'tmc-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      callback(result);
    });
  }

  public openTakeBackSupplementaryEquipmentDialog(transportId: number, callback: () => any) {
    const dialogRef = this.dialog.open(SupplementaryEquipmentTakeBackComponent, {
      maxHeight: '95vh',
      data: { transportId: transportId },
      panelClass: 'tmc-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      callback();
    });
  }

  public openRegisterEntranceDialog(transportId: number, callback: (result: any) => any) {
    this.performRegisterEntrance(transportId, callback);
  }

  private performRegisterEntrance(transportIdentifier: number, callback: (result: any) => any) {
    let dialogRef = null;
    if (this.configurationService.isPropertyTrue(this.clientParameters.FEATURES_COMBINED_ENTRANCE, false)) {
      const dialogData: RegisterEntranceCombinedDialogData = {
        transportId: transportIdentifier,
        callback: () => { }
      };

      dialogRef = this.dialog.open(RegisterEntranceCombinedComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });

    } else {
      const dialogData: RegisterEntranceDialogData = {
        transportId: transportIdentifier,
        callback: () => { }
      };

      dialogRef = this.dialog.open(RegisterEntranceComponent, {
        maxHeight: '95vh',
        data: dialogData,
        panelClass: 'tmc-dialog-container'
      });
    }
    dialogRef.afterClosed().subscribe(result => {
      callback(result);
    });
  }

  public createHandout(transportId: number, documentIdentifier: string) {
    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'emergency');

    // keep focus in current window
    window.focus();

    const url = `/client/control/transportoverview/print-handout`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, { transportId: transportId, documentIdentifier: documentIdentifier }).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }
}
